import { render, staticRenderFns } from "./CollectionDetail.vue?vue&type=template&id=ee1c5932&scoped=true"
import script from "./CollectionDetail.vue?vue&type=script&lang=js"
export * from "./CollectionDetail.vue?vue&type=script&lang=js"
import style0 from "./CollectionDetail.vue?vue&type=style&index=0&id=ee1c5932&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1c5932",
  null
  
)

export default component.exports